export default __webpack_public_path__ + "static/media/good_luck_w_your_ears_honestly.70e21045.mp3";